import React from "react";
import { Formik, Form } from "formik";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import { Switch } from "react-router-dom";
//*
import { editUsersData } from "../Redux/Creators/UsersCreators";
import { FaCheckCircle } from "react-icons/fa"; 

const RegisterUserSuccess = (props) => {
  console.log("handleSubmit", props.registerUser);
  const mainContent = React.useRef(null);
  const handleSubmit = (values, setSubmitting) => {
    console.log("handleSubmit", "handleSubmit");
    let data = new FormData();

    data.append("name", values.name);
    data.append("token", props.registerUser);
    data.append("email", values.email);
    data.append("role", values.role);
    data.append("password", values.password);
    data.append("password_confirmation", values.password_confirmation);
    data.append("mobile_no", values.mobile_no);
    data.append("designation", values.designation);
    data.append("join_date", values.join_date);
    data.append("pincode", values.pincode);
    data.append("status", values.status);
    data.append("user_pincodes", JSON.stringify(values.user_pincodes));
    data.append("banks", values.banks);
    data.append("branch_master_id", values.branch_master_id);
    // data.append("case_types", values.case_types);
    data.append("user_type", values.user_type);
    data.append("ref_name", values.ref_name);
    data.append("ref_number", values.ref_number);
    data.append("adhaar_no", values.adhaar_no);
    data.append("address", values.address);
    data.append("pancard_no", values.pancard_no);
    data.append("account_number", values.account_number);
    data.append("acc_name", values.acc_name);
    data.append("ifsc_code", values.ifsc_code);
    data.append("branch_name", values.branch_name);
    data.append("joing_type", values.joing_type);
    data.append("branch_head_approval", values.branch_head_approval);
    data.append("master_approval", values.master_approval);
    data.append("cv_file", values.cv_file);
    data.append("adhaar_card_file", values.adhaar_card_file);
    data.append("adhaar_card_file", values.adhaar_card_file);
    data.append("kyc", values.kyc);
    data.append("marksheet", values.marksheet);
    data.append("driving_licence_file", values.driving_licence_file);
    data.append("photograph", values.photograph);
    data.append("bank_name", values.emp_bank_name);
    data.append("personal_contact", values.personal_contact);
    data.append("father_contact", values.father_contact);
    data.append("mother_contact", values.mother_contact);
    data.append("mother_contact", values.mother_contact);
    props.editUsersData(data);
    // props.registerUser(data);
    setSubmitting(false);
    return;
  };
  return (
    <React.Fragment>
      <div
        className="main-content"
        style={{ "background-color": "#172b4d" }}
        ref={mainContent}
      >
        <AuthNavbar />
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h1 className="text-white">Welcome!</h1>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className="mt--9 pb-5">
          <Row className="justify-content-center">
            <Switch>
              <>
                <Col lg="10" md="7">
                  {/* <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-1 text-blue h2"></CardHeader>

                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <small>Register Success</small>
                      </div>
                      
                     
                    </CardBody>
                  </Card> */}
                   <Card className="bg-secondary shadow border-0">
      <CardHeader className="bg-transparent pb-1 text-blue h2 text-center">
        <FaCheckCircle color="green" size="3em" className="mb-3" /> {/* Success Icon */}
        Registration Successful!
      </CardHeader>

      <CardBody className="px-lg-5 py-lg-5">
        <div className="text-center text-muted mb-4">
          <h3>Congratulations, your application has been submitted successfully!</h3>
          <h5>
            After verification, you will receive an email with instructions for the document submission and further details.
          </h5>
        </div>

        <div className="text-center">
          <Button color="primary" size="md" onClick={() => window.location.href = "/login"}>
            Go to Login
          </Button>
        </div>
      </CardBody>
    </Card>
                  <Row className="mt-3">
                    <Col xs="6">
                      <Link
                        className="text-light"
                        to="/forgot-password"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            > */}
                        <small>Forgot password?</small>
                        {/* </a> */}
                      </Link>
                    </Col>
                    <Col className="text-right" xs="6">
                      <Link
                        className="text-right"
                        to="/register-user"
                        xs="6"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            > */}
                        <small>Create new account</small>
                        {/* </a> */}
                      </Link>
                    </Col>
                  </Row>
                </Col>
              </>
            </Switch>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    login: state.login,
    dropdowns: state.dropdowns,
    registerUser: state.registerUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editUsersData: (data) => dispatch(editUsersData(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RegisterUserSuccess);
